import { DSDisciplines } from '../../../cimsPage/instances/ds'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const disciplines = CreateViewEditSoftRemoveRestore({
  page: DSDisciplines,
  object: 'Discipline',
  create: '080adcfb-e1ef-4f05-9fef-ad42da79f0d4',
  view: 'df7d39a6-193d-4584-a1a2-98f9bc4ed578',
  edit: 'd4d8840f-fa95-4a48-b6e8-cb4726e5a4a4',
  removeRestore: '57237795-206b-4ac3-85e2-7f4b37c5b6c2',
})

export const CreateDesignSubmittalDiscipline = disciplines.Create
export const ViewDesignSubmittalDiscipline = disciplines.View
export const EditDesignSubmittalDiscipline = disciplines.Edit
export const RemoveRestoreDesignSubmittalDiscipline = disciplines.RemoveRestore

export type DSDisciplinePermission =
  | typeof CreateDesignSubmittalDiscipline
  | typeof ViewDesignSubmittalDiscipline
  | typeof EditDesignSubmittalDiscipline
  | typeof RemoveRestoreDesignSubmittalDiscipline
